<template>
    <div>
        <a
            v-if="canAddToGroup"
            class="btn text-sm is-ghost"
            @click="$modal.show('add-to-group')"
        >
            Lägg till i grupp
        </a>
        <adaptive-form-modal
            name="add-to-group"
            primary-button-text="Lägg till adresser"
            primary-button-class="is-primary"
            title="Lägg till adresser till befintlig grupp"
            method="post"
            :action="actionRoute"
        >
            <select-input
                v-model="groupId"
                :options="formattedGroups"
                :required="true"
            >
                Grupp
            </select-input>

            <div class="mt-lg">
                Antal adresser: {{ selectedAddresses.length }}
                <div v-for="address in selectedAddresses">
                    <input
                        type="hidden"
                        name="addresses[]"
                        :value="address.id"
                    >
                </div>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
            groups: {
                type: Array,
                required: true,
            },
            selectedAddresses: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                groupId: '',
            };
        },
        computed: {
            canAddToGroup() {
                return this.groups.length > 0;
            },
            formattedGroups() {
                const arr = {};
                this.groups.map((group) => {
                    arr[group.id] = group.name;
                });
                return arr;
            },
            actionRoute() {
                return route('api.sales-projects.groups.add-addresses', [this.project, this.groupId]);
            },
        },
        created() {
            if (this.canAddToGroup) {
                this.groupId = this.groups[0]['id'];
            }
        },
    };
</script>
